/* Featured artwork carousel - Swiper init scoped per section instance */
(function () {
  var SECTION_SELECTOR = '.featured-artwork';
  var ROOT_SELECTOR = '.js-featured-artwork';
  var observers = [];

  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  function buildOptions(root, section) {
    var desktop = parseInt(root.dataset.desktop, 10) || 4;
    var tablet = parseInt(root.dataset.tablet, 10) || 3;
    var mobile = parseInt(root.dataset.mobile, 10) || 2;
    var autoplayOn = root.dataset.autoplay === 'true';
    var loopOn = root.dataset.loop === 'true';
    var delay = parseInt(root.dataset.autoplayDelay, 10) || 5000;
    var slideCount = root.querySelectorAll('.swiper-slide').length;

    var options = {
      slidesPerView: mobile,
      slidesPerGroup: 1,
      spaceBetween: 12,
      loop: loopOn && slideCount > desktop,
      watchOverflow: true,
      simulateTouch: true,
      allowTouchMove: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous artwork',
        nextSlideMessage: 'Next artwork'
      },
      mousewheel: {
        forceToAxis: true
      },
      breakpoints: {
        0: { slidesPerView: mobile, spaceBetween: 12 },
        750: { slidesPerView: tablet, spaceBetween: 20 },
        1100: { slidesPerView: desktop, spaceBetween: 24 }
      }
    };

    var pagination = root.querySelector('.js-featured-artwork-pagination');
    if (pagination) {
      options.pagination = {
        el: pagination,
        clickable: true,
        bulletClass: 'featured-artwork__bullet',
        bulletActiveClass: 'featured-artwork__bullet--active'
      };
    }

    var prev = section.querySelector('.js-featured-artwork-prev');
    var next = section.querySelector('.js-featured-artwork-next');
    if (prev && next) {
      options.navigation = { prevEl: prev, nextEl: next };
    }

    if (autoplayOn && slideCount > 1) {
      options.autoplay = {
        delay: delay,
        disableOnInteraction: false,
        pauseOnMouseEnter: !isTouchDevice()
      };
    }

    return options;
  }

  function destroy(scope) {
    var context = scope || document;
    context.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (root.swiper) root.swiper.destroy(true, true);
    });
  }

  function init(scope) {
    if (typeof Swiper === 'undefined') return;
    var context = scope || document;
    context.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (root.swiper) return;
      var section = root.closest(SECTION_SELECTOR) || root.parentNode;
      /* eslint-disable no-new */
      new Swiper(root, buildOptions(root, section));
    });
  }

  function observeSection(section) {
    if (typeof ResizeObserver === 'undefined') return;
    var observer = new ResizeObserver(function () {
      var root = section.querySelector(ROOT_SELECTOR);
      if (root && root.swiper) root.swiper.update();
    });
    observer.observe(section);
    observers.push(observer);
  }

  function boot(scope) {
    destroy(scope);
    init(scope);
    (scope || document).querySelectorAll(SECTION_SELECTOR).forEach(observeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target || document;
    if (target.querySelector && target.querySelector(ROOT_SELECTOR)) {
      boot(target);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    if (target && target.querySelector && target.querySelector(ROOT_SELECTOR)) {
      destroy(target);
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;
    var root = target.querySelector(ROOT_SELECTOR);
    if (root && root.swiper && root.swiper.autoplay) root.swiper.autoplay.stop();
  });
})();
